<template>
  <article
    class="cr-row ctx-row"
    role="listitem"
    tabindex="0"
    @click="$emit('view', context)"
    @keydown.enter.prevent="$emit('view', context)"
  >
    <div class="ctx-row__name">
      <v-icon icon="mdi-text-box-outline" size="16" class="ctx-row__name-icon" />
      <span class="ctx-row__name-value" :title="context.context_name">
        {{ context.context_name }}
      </span>
    </div>

    <div class="ctx-row__files">
      <span class="cr-row__field-label">Files</span>
      <div class="ctx-row__files-main">
        <span
          class="ctx-files-badge"
          :class="
            context.pendingCount > 0
              ? 'ctx-files-badge--pending'
              : context.fileCount > 0
                ? 'ctx-files-badge--ready'
                : 'ctx-files-badge--empty'
          "
          :title="filesTitle"
        >
          {{ context.filesLabel }}
        </span>
        <ul v-if="context.kb_files?.length" class="ctx-row__file-names">
          <li
            v-for="file in context.kb_files.slice(0, 2)"
            :key="file.id"
            class="ctx-row__file-name"
            :title="`${file.filename} · ${file.uploadedOnLabel}`"
          >
            <v-icon
              :icon="file.pending ? 'mdi-clock-outline' : 'mdi-check-circle-outline'"
              size="12"
            />
            {{ file.filename }}
          </li>
          <li
            v-if="context.kb_files.length > 2"
            class="ctx-row__file-name ctx-row__file-name--more"
          >
            +{{ context.kb_files.length - 2 }} more
          </li>
        </ul>
      </div>
    </div>

    <div class="ctx-row__status">
      <span class="cr-row__field-label">Status</span>
      <span
        class="ctx-status-badge"
        :class="
          context.disabled
            ? 'ctx-status-badge--disabled'
            : 'ctx-status-badge--active'
        "
      >
        {{ context.statusLabel }}
      </span>
    </div>

    <div class="ctx-row__created">
      <span class="cr-row__field-label">Created</span>
      <span class="ctx-row__created-value">{{ context.createdOnLabel }}</span>
    </div>

    <div class="cr-row__actions" @click.stop>
      <ContextsActionMenu
        :context="context"
        @view="$emit('view', $event)"
        @edit="$emit('edit', $event)"
        @enable="$emit('enable', $event)"
        @disable="$emit('disable', $event)"
        @delete="$emit('delete', $event)"
      />
    </div>
  </article>
</template>

<script setup>
import { computed } from 'vue'
import ContextsActionMenu from '@/components/Contexts/ContextsActionMenu.vue'

defineOptions({ name: 'ContextsRow' })

const props = defineProps({
  context: { type: Object, required: true },
})

defineEmits(['view', 'edit', 'enable', 'disable', 'delete'])

const filesTitle = computed(() => {
  const files = props.context?.kb_files || []
  if (!files.length) return 'No files attached'
  return files
    .map((file) => `${file.filename}: ${file.uploadedOnLabel}`)
    .join('\n')
})
</script>

<style scoped>
/* Whole row navigates to the product's detail page now (mirrors
   CampaignsPage.vue's own row click) -- the actions menu button below
   stops its own click from bubbling here, so it isn't affected. */
.ctx-row {
  cursor: pointer;
}
.ctx-row:focus-visible {
  outline: 2px solid var(--tw-accent, #4f46e5);
  outline-offset: -2px;
}
</style>
